<template>
    <div>
      <content-header :title="`${getEntityType} Details`" :sub-title="`Enter your ${getEntityType}'s contact information.`" class="mb-0 mt--10"/>
      <el-form ref="form" :model="registration" :rules="rules" label-position="top" v-if="isLoaded">
        <h3>{{getEntityType }} Details</h3>
        <el-row :gutter="60">
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Entity Name</el-input-title>
            <el-form-item prop="entity.name">
              <el-input :disabled="hasEntitySelected" class="mt-05" v-model="registration.entity.name" placeholder="Type here..."/>
            </el-form-item>
          </el-col>
          <div v-if="national !== 4">
            <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Contact Full Name</el-input-title>
            <el-form-item prop="entity.contact.name">
              <el-input class="mt-05" v-model="registration.entity.contact.name" placeholder="Type here..." :disabled="hasEntitySelected"/>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Contact Mobile</el-input-title>
            <el-form-item prop="entity.contact.number">
              <vue-tel-input
              :disabled="hasEntitySelected"
               autoFormat
               autoDefaultCountry
               :defaultCountry="countryCode"
               dropdownOptions.showDialCodeInSelection="false"
               @open="openFlagDropdown = true"
              @close="openFlagDropdown = false"
              @country-changed="handleCountryChanged"
               v-model="registration.entity.contact.number">
                <template v-slot:arrow-icon>
                  <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
                </template>
              </vue-tel-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Contact Email</el-input-title>
            <el-form-item prop="entity.contact.email">
              <el-input class="mt-05" v-model="registration.entity.contact.email" placeholder="Type here..." :disabled="hasEntitySelected"/>
            </el-form-item>
          </el-col>
          </div>
        </el-row>
        <el-form-item v-if="isTCRequired">
          <el-checkbox v-model="isTCAccepted" size="medium" class="mt-10">I agree to the <a href="javascript: void(0);" @click="dialogVisible = true">Terms and Conditions</a></el-checkbox>
        </el-form-item>
      </el-form>
      <el-dialog
        :visible.sync="dialogVisible"
        :fullscreen="true"
        v-if="isTCRequired"
        >
        <div style="width:100%;height:100%">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="src"
            :page="i"
          ></pdf>

        </div>
        </el-dialog>
    </div>
  </template>

<script>
import _ from 'lodash';
import {
  errormsg,
  // genders
} from '@/utils/constants';
import { VueTelInput } from 'vue-tel-input';
import { checkEmail, parseBirthdate } from '@/utils/form-helpers';
import pdf from 'vue-pdf';
import {
// calculateMemberAge
} from '@/utils/helpers';

const { parsePhoneNumberFromString } = require('libphonenumber-js');

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };
// const validateEmail = {
//   required: false,
//   trigger: 'blur',
//   validator: (rule, value, callback) => {
//     if (!value) return callback();
//     const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     if (value && re.test(String(value).toLowerCase())) return callback();
//     return callback(new Error('Invalid email address'));
//   }
// };
const validateMobile = {
  required: false,
  trigger: 'blur',
  validator: (rule, value, callback) => {
    if (!value) return callback();
    // eslint-disable-next-line no-param-reassign
    value = value.replace(/\s/g, '');
    const phoneNumber = parsePhoneNumberFromString(value, this.countryCode);
    const test = !!(((phoneNumber && phoneNumber.isValid())));
    if (test) return callback();
    return callback(new Error('Invalid mobile'));
  }
};

export default {
  name: 'EntityDetails',
  props: {
    value: Object,
    membership: Object
  },
  components: {
    pdf,
    VueTelInput
  },
  data() {
    return {
      openFlagDropdown: false,
      countryDialCode: this.getCountryDialCode(),
      countryCode: this.getCountryCode(),
      isLoaded: false,
      registration: {},
      products: this.membership.products,
      additionalQs: this.membership.additionalQs,
      saleableItems: this.membership.saleableItems,
      discounts: this.membership.discounts,
      isTCAccepted: false,
      isTCRequired: false,
      dialogVisible: false,
      rules: {
        product: defaultRequiredRule,
        'entity.name': defaultRequiredRule,
        'entity.contact.name': defaultRequiredRule,
        'entity.contact.number': { validator: validateMobile, trigger: 'blur' },
        'entity.contact.email': { validator: checkEmail, trigger: 'blur' },
      },
      numPages: undefined,
      hasEntitySelected: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.$store.commit('loading', { loading: true, text: 'Loading...' });
    this.isTCRequired = this.membership && this.membership.products && this.membership.products[0].isTCRequired ? this.membership.products[0].isTCRequired : false;
    if (this.isTCRequired) {
      try {
        const resMembership = await this.$http.get(`/assemble/api/v1/portal/files/entity/${this.membership._id}/product/${this.membership.products[0]._id}/signed`);
        const url = resMembership.data.url.toString();
        try {
          this.src = pdf.createLoadingTask(url);
          const data = await pdf.createLoadingTask(url).promise;
          this.numPages = data._pdfInfo.numPages;
          this.isTCAccepted = this.membership.products[0].isTCPrefilled;
        } catch (error) {
          this.isTCRequired = false;
        }
        this.$store.commit('loading', false);
      } catch (error) {
        this.isTCRequired = false;
        this.$store.commit('loading', false);
      }
    } else {
      this.$emit('tc-update', false);
    }
    console.log('this membership', this.membership);

    if (this.value.entity === undefined) {
      const {
        _id, productType, tags, additionalQs, saleableItems, discounts, products, entity
      } = this.membership;
      if (entity) this.hasEntitySelected = true;

      this.registration = {
        existingEntity: this.hasEntitySelected,
        membershipId: _id,
        productType,
        entityRegoType: this.membership.selectedEntity,
        tags,
        entity: entity || {
          name: undefined,
          contact: {
            name: undefined,
            number: undefined,
            email: undefined,
          },
        },
        product: products[0],
        additionalQs,
        saleableItems,
        discounts
      };
      if (this.hasEntitySelected) {
        _.assign(this.registration, { hasEntitySelected: true });
      }
      this.$emit('update-step', this.registration, 0);
    } else this.registration = this.value;

    this.isLoaded = true;
    this.$store.commit('loading', false);
  },
  methods: {
    getCountryDialCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return '64'; // New Zealand
        case 21:
          return '65'; // Singapore
        default:
          return '61'; // Australia (default)
      }
    },

    getCountryCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return 'NZ'; // New Zealand
        case 21:
          return 'SG'; // Singapore
        default:
          return 'AU'; // Australia (default)
      }
    },
    handleCountryChanged(countryCode) {
      this.countryDialCode = countryCode.dialCode;
    },
    refactorMobile(mobileNumber) {
      let mobile = _.cloneDeep(mobileNumber).replace(/\s/g, '');
      if (mobile.charAt(0) === '0') {
        mobile = mobile.substring(1);
        return `+${ this.countryDialCode }${mobile}`;
      } if (mobile.charAt(0) === '+') {
        return mobile;
      }
      if (!mobile.length) {
        return undefined;
      }
      return `+${ this.countryDialCode }${mobile}`;
    },
    updateStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (_.get(this.registration, 'entity.contact.number')) {
            this.registration.entity.contact.number = this.refactorMobile(this.registration.entity.contact.number);
          }
          console.log('this.registration at entity', this.registration);
          this.registration.additionalQs = _.filter(this.additionalQs, (v) => v.entityTypeList.find((item) => item.value === this.membership.selectedEntity));
          this.registration.saleableItems = _.filter(this.saleableItems, (v) => v.entityTypeList.find((item) => item.value === this.membership.selectedEntity));
          this.registration.discounts = _.filter(this.discounts, (v) => v.entityTypeList.find((item) => item.value === this.membership.selectedEntity));
          this.registration.meta = undefined;
          this.$emit('update-step', this.registration);
        }
      });
    },
  },
  filters: {
    formatDob(val) {
      return parseBirthdate(val, true);
    },
    productFilter(val) {
      return `Age(${val.ageFrom} - ${val.ageTo}) - $${(val.price / 100).toFixed(2)}`;
    }
  },
  computed: {
    getEntityType() {
      if (this.value && this.value.product) {
        console.log('value', this.value);
        const entityType = this.value.product.entityTypeList.find((item) => item.value === this.value.entityRegoType);
        return entityType ? entityType.name : '';
      }
      return '';
    },
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
  },
  watch: {
    isTCAccepted(val) {
      this.$emit('tc-update', !val);
    }
  }
};
</script>

  <style scoped lang="scss">
  .manualAddressBtn {
    &:hover {
      color: var(--highlight-color) !important;
    }
  }

  ::v-deep .el-dialog {
    max-width: 900px !important;
  }
  </style>
